import type { Step } from "react-joyride";

export const usageAndBillingTourSteps: Step[] = [
  {
    target: "#tour-feature-usage-card",
    content:
      "Track feature usage across all features with percentage changes and visual charts.",
    placement: "bottom",
    disableBeacon: true,
  },
  {
    target: "#tour-live-activity-card",
    content:
      "Monitor real-time activity with auto-refreshing metrics, session stats, and spike detection.",
    placement: "bottom",
    disableBeacon: true,
  },
  {
    target: "#tour-users-table",
    content:
      "This table lists detailed user activity including sessions, feature usage, and more. Click on a row to see session details.",
    placement: "top",
    disableBeacon: true,
  },
];
